import {styled} from "@core-ui/react-stitch";
import {ProductGridRootProps} from "../../types";

const ProductGridRoot = styled.section<ProductGridRootProps>(
  ({isBRRedesignEnabled}: ProductGridRootProps) => ({
    boxSizing: "border-box",
    padding: isBRRedesignEnabled ? "0" : "0.5em",
  })
);

export default ProductGridRoot;
